import { For } from "solid-js";
import type { RelevancyRating } from "../api/domain.ts";
import { relevancyWeight } from "../api/domain.ts";
import { useI18n } from "../i18n/provider.tsx";
import { formatWeight } from "../lib/format.ts";
import { relevancySteps } from "./Form.tsx";
import styles from "./RelevancyMark.module.scss";

export type RelevancyMarkProps = {
  rating: RelevancyRating;
};

/**
 * A stored rating, drawn the way the recipient picked it: the same five-step
 * track as the fill page, with only the chosen step lit. The step's name and
 * the weight it turns into sit in the title, so the reader hovers for the
 * number and scans the colour for the shape of a persona's priorities.
 */
export const RelevancyMark = (props: RelevancyMarkProps) => {
  const i18n = useI18n();
  const label = () =>
    `${i18n.t().relevancy.scale[props.rating]} · ${i18n.t().relevancy.weight} ${formatWeight(
      relevancyWeight(props.rating),
      i18n.locale(),
    )}`;

  return (
    <span class={styles.mark} role="img" aria-label={label()} title={label()}>
      <For each={relevancySteps}>
        {(step) => (
          <span
            class={`${styles.step} ${styles[step.tone]} ${
              step.rating === props.rating ? styles.picked : ""
            }`}
            aria-hidden="true"
          >
            {step.label}
          </span>
        )}
      </For>
    </span>
  );
};
